import { useAuth } from "../../context/auth-context";
import type {
  InviteCodesMetricsEnvelope,
  InviteCodesMetricsPayload,
} from "./inviteCodes";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

export function useInviteCodesMetricsQuery(enabled = true) {
  const { isAuthenticated } = useAuth();

  return useApiQuery<InviteCodesMetricsEnvelope, InviteCodesMetricsPayload>({
    queryKey: apiQueryKey("invite-codes-metrics"),
    url: "api/invite-codes/metrics",
    enabled: Boolean(isAuthenticated) && enabled,
    select: (body) => body.data,
  });
}
